<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <a class="nav-link mr20 navbar-head-dropdown"><!--icon icon="globe"></icon--><img src="../../../../assets/img/croatia.svg"><p>Hrvatski</p><icon icon="caret-down"></icon></a> <!-- VRBA ovdje umjesto hardkodanog hrvatski treba ubacit odabrani jezik + ikona zastavice isto tak, u assets su stavljene HR i UK zastavice, ako ces trebat jos neke, javi pa napravim -->
        </template>
        <b-dropdown-item v-for="item in data.root" :key="item.langId" v-on:click="fetchLanguage(item.langId)">
            <a>{{$t(item.langName)}}</a>
        </b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Api from '@/api/admin/TransLang';

export default
{
    name: 'header-dropdown-accnt',
    created()
    {
        const me = this;
        me.getData();
    },
    data()
    {
        return {
            data: {},
            pagination:
      {
          currentPage: 1,
          limit: 20,
      },
        };
    },
    methods:
  {
      ...mapActions([
          'fetchLanguage',
      ]),
      getData()
      {
          const me = this;
          Api.selectRow(me.pagination, (data) =>
          {
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.data = data;
          });
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
  },
};
</script>
